// ISDP CUSTOM — i18n framework, shared "common" namespace.
//
// We use Backstage's official translation system (createTranslationRef + useTranslationRef,
// language driven by appLanguageApiRef). Each area of the app owns a namespace ref like this one:
//   - English is the source of truth and lives inline in `messages` (nested; keys flatten with dots).
//   - Other languages are lazy-imported from ./de/<ns> etc. — a flat map of "dotted.key" -> string.
// Components read strings with:  const { t } = useTranslationRef(commonMessages); t('nav.catalog')
// Adding a language = add it to availableLanguages in App.tsx and add a ./<lang>/<ns>.ts file per ref.
import { createTranslationRef } from '@backstage/core-plugin-api/alpha';

export const commonMessages = createTranslationRef({
  id: 'devhub.common',
  messages: {
    nav: {
      catalog: 'Catalog',
      guides: 'Getting Started',
      docs: 'Documentation',
      resources: 'Resources',
      news: 'News',
      community: 'Community',
      menu: 'Menu',
      closeMenu: 'Close menu',
    },
    admin: {
      insights: 'Insights',
      content: 'Content',
      access: 'Access',
      system: 'System',
      admin: 'Admin',
    },
    docsMenu: {
      gettingStarted: 'Getting Started',
      curated: 'Curated Docs',
      all: 'All Docs',
    },
    profile: {
      account: 'Account',
      settings: 'Settings',
      darkMode: 'Dark Mode',
      lightMode: 'Light Mode',
      signOut: 'Sign Out',
      viewPartnerPortal: 'View Partner Portal',
    },
    language: {
      label: 'Language',
      english: 'English',
      german: 'Deutsch',
    },
    // Custom, trimmed General settings panel (components/settings/).
    settings: {
      profile: 'Profile',
      appearance: 'Appearance',
      theme: 'Theme',
      themeDescription: 'Choose how the DevHub looks.',
      light: 'Light',
      dark: 'Dark',
      languageDescription: 'Language for the interface.',
      identity: 'Identity',
      user: 'User',
      groups: 'Groups',
      noGroups: 'No group memberships',
      guest: 'Guest',
    },
    search: {
      hint: 'Search',
    },
    starred: {
      title: 'Starred entities',
      empty: 'Star catalog entries to see them here — browse the Catalog to get started.',
      browseCatalog: 'Browse the Catalog',
      error: 'Your starred entities couldn’t be loaded. Please try again later.',
    },
    // Truly-shared action labels reused across many screens.
    actions: {
      save: 'Save',
      cancel: 'Cancel',
      delete: 'Delete',
      remove: 'Remove',
      add: 'Add',
      edit: 'Edit',
      close: 'Close',
      create: 'Create',
      back: 'Back',
      download: 'Download',
      copy: 'Copy',
      copied: 'Copied',
      loading: 'Loading…',
    },
    // Partner/public (external) shell chrome — nav, sign-in, tier labels, footer, profile menu.
    external: {
      products: 'Products',
      gettingStarted: 'Getting Started',
      partnerProgram: 'Partner Program',
      contact: 'Contact',
      signIn: 'Sign In',
      mcpAccess: 'MCP Access',
      internalHub: 'Internal Hub',
      signOut: 'Sign Out',
      tierRegistered: 'Registered Partner',
      tierPremium: 'Premium Partner',
      footerMedical: 'Medical Products',
      footerDocs: 'Documentation',
    },
  },
  translations: {
    de: () => import('./de/common'),
  },
});
